import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";

type AuthResponse = {
  token: string;
  expiresAt: string;
};

let authResponse: AuthResponse | null = JSON.parse(
  (localStorage.getItem("authResponse") as any) || "null"
);

export const setAuthResponse = (newResponse: AuthResponse) => {
  localStorage.setItem("authResponse", JSON.stringify(newResponse));
  authResponse = newResponse;
  client.resetStore();
};

export const clearAuthResponse = () => {
  authResponse = null;
  localStorage.removeItem("authResponse");
  client.resetStore();
};

const SERVER_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.chess2online.com/graphql"
    : `http://${window.location.hostname}:4000/graphql`;
const httpLink = createHttpLink({ uri: SERVER_URL });

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: authResponse ? `Bearer ${authResponse.token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
